import React from "react";
import Herosection from "../components/projectmanagement/Herosection";
import Services from "../components/projectmanagement/Services";
import Section3 from "../components/projectmanagement/Section3";
import Projectmanagement from "../components/projectmanagement/Projectmanagement";

const ProjectManagement = () => {
  return (
    <div className="w-full flex flex-col items-center gap-5 lg:gap-[72px] ruler">
      <Herosection />
      <Services />
      <Section3 />
      <Projectmanagement />
    </div>
  );
};

export default ProjectManagement;
